// extracted by mini-css-extract-plugin
export default {"label_spec":"AnnouncementList_label_spec__d0OhU","root":"AnnouncementList_root__UhPx4","successBanner":"AnnouncementList_successBanner__r1O4D"};